module.exports = __webpack_public_path__ + "static/eddd-dbdb876308e8885d4fa17aeb775bf8aa.png";